module.exports = __webpack_public_path__ + "static/media/post3.62647af9.jpg";